// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".list-item>span[data-v-e46ed5bc]{position:absolute;right:100%;top:9px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
